export default "__VITE_ASSET__b30f0099__"